import { forwardRef, useEffect, useRef, useState, useImperativeHandle } from "react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { CKEditorOptions } from "util";
import { html_render } from "pages/Review/Functions";
const DescEditor = (props, ref) => {
    const { data, revData } = props;
    const [WEB_CONTENT, SET_WEB_CONTENT] = useState(null);
    const viewRef = useRef(null);
    const editorRef = useRef(null);
    const reviewRef = useRef(null);

    useImperativeHandle(ref, () => ({
        getData: () => {
            return editorRef.current.getData();
        },
    }));

    const HandleReviewEvent = (e) => {
        const { target } = e;
        const isUniqueCode = target?.closest("[data-uniquecode]");
        if (!isUniqueCode) return;

        const uniqueCode = isUniqueCode.dataset.uniquecode;

        if (!uniqueCode) return;

        reviewRef.current.querySelectorAll(".selected").forEach((e) => {
            e.classList.remove("selected");
        });
        target.classList.add("selected");

        props?.onOpen && props.onOpen("Description Review Data", props.revtype, uniqueCode);

        const editortarget = viewRef.current.querySelector("[data-uniquecode='" + uniqueCode + "']");
        if (!editortarget) return;

        editortarget.classList.add("bpl-review-selected");
        setTimeout(() => {
            editortarget.classList.remove("bpl-review-selected");
        }, 5000);
        const elementPosition = editortarget.getBoundingClientRect();
        const offsetPosition = elementPosition.top + window.scrollY - 200;
        window.scrollTo({
            top: offsetPosition,
            behavior: "smooth",
        });
    };

    useEffect(() => {
        reviewRef?.current?.addEventListener("click", HandleReviewEvent);
        return () => {
            reviewRef?.current?.removeEventListener("click", HandleReviewEvent);
        };
    }, [WEB_CONTENT,revData]);

    useEffect(() => {
        if (editorRef.current || data) {
            setTimeout(() => {
                editorRef.current.setData(data);
            }, 300);
        }
    }, [data]);

    const HandleChangeEvent = (editor) => {
        const review = revData?.filter((f) => f.celNm === "Description Review Data");
        const content = editor?.getData();
        const a = html_render(content, review);
        SET_WEB_CONTENT(a);
    };

    useEffect(() => {
            HandleChangeEvent(editorRef.current);
    }, [revData]);

    
    

    return (
        <div className={"maindesc-editor"}>
            <div className={"editor-aria"} ref={viewRef}>
                <CKEditor
                    editor={Editor}
                    config={CKEditorOptions}
                    watchdogConfig={{ crashNumberLimit: 10 }}
                    onReady={(editor) => {
                        window.editor = editor;
                        editorRef.current = editor;
                        editor.editing.view.document.on('clipboardInput', (evt, data) => {
                            
                            const dt = data.dataTransfer;
                            const content = dt.getData("text/plain");
                            
                            data.content = editor.data.htmlProcessor.toView( content );
                            const editingView = editor.editing.view;
                            editingView.scrollToTheSelection();
                        })
                    }}
                    onChange={(event, editor) => {
                        HandleChangeEvent(editor);
                    }}
                />
            </div>
            <div className={"view-area"}>
                <div className={"inner"}>
                    <div className={"inner2"}>
                        <div className={"name-plate"}>Preview</div>
                        <div
                            ref={reviewRef}
                            className={"ck-content"}
                            dangerouslySetInnerHTML={{ __html: WEB_CONTENT || "" }}
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default forwardRef(DescEditor);
